import { RouterPageProps } from "../classesAndInterfaces/generalInterfaces";
import Home from "./Home/Home";

const routes: {
  url: string;
  component: RouterPageProps;
}[] = [
  {
    url: "/",
    component: Home,
  },
];

export { routes };
